import React from "react";
import styled from "styled-components";

function _extends() {
  // eslint-disable-next-line
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

const FloatingLabelInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  height: 4em;
  border-bottom: 1px solid ${(props) => props.borderColor || "#c1c1c1"};
  font-size: inherit;
  & > label {
    color: ${(props) => props.labelColor || "#B69957"};
  }
`;
const FloatingLabel = styled.label`
  position: absolute;
  color: #9b9b9b;
  top: 25%;
  bottom: 0;
  transition: all 0.2s ease-in-out;
  transform-origin: left top;
  cursor: text;
  pointer-events: none;
  width: 100%;
  margin-bottom: ${(props) => (props.active ? "1.5rem" : "1rem")};
  transform: ${(props) =>
    props.active ? "translate3d(0, -160%, 0) scale(0.9)" : "none"};
`;
const FloatingSpan = styled.span``;
const FloatingInput = styled.input`
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  border-color: #c1c1c1;
  height: 2.7em;
  &::placeholder {
    color: #9b9b9b;
    opacity: ${(props) => (props.active ? 1 : 0)};
    transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);
  }
`;
class FloatInput extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!props.id && !props.name) {
      throw new Error("expected id but none present");
    }

    this.state = {
      active: props.value && props.value.length > 0,
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.active &&
      this.props.value &&
      prevProps.value !== this.props.value
    ) {
      this.setState({
        active: true,
      });
    }
  }

  onFocus(event) {
    this.setState({
      active: true,
    });

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  }

  onBlur(event) {
    this.setState({
      active: event.target.value.length !== 0,
    });

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  render() {
    const {
      id,
      label,
      span,
      onBlur,
      onFocus,
      type,
      refs,
      labelColor,
      borderColor,
      classNameWrapper,
      className,
      classNameLabel,
      classNameSpan,
      classNameInput,
      options,
      ...otherProps
    } = this.props;
    const { active } = this.state;
    return React.createElement(
      FloatingLabelInputContainer,
      {
        className: className,
        labelColor: labelColor,
        borderColor: borderColor,
      },
      React.createElement(
        FloatingLabel,
        {
          className: classNameLabel,
          htmlFor: id,
          active: active,
        },
        label,
        React.createElement(
          FloatingSpan,
          {
            className: classNameSpan,
            htmlFor: id,
            active: active,
          },
          span
        )
      ),
      React.createElement(
        FloatingInput,
        _extends(
          {
            active: active,
            className: classNameInput,
            id: id,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            ref: refs,
            type: type,
          },
          otherProps
        )
      )
    );
  }
}

export default FloatInput;
